import Storage from "../Storage/Storage";
import Http from "../Http/Http";
import Store from "../Store/Store";
import Translator from "../Translation/Translator";
import Constants from "../Action/Constants";
import Decoder from "./Decoder";

class Token {

  private interval: any;

  constructor() {
    this.attachInitialToken();
  }

  public watch(): any {
    clearInterval(this.interval);

    const token = Storage.getInstant("token");

    if (!token) {
      return;
    }

    this.interval = setInterval(() => {
      const jwtToken = Decoder.decode(token);

      // If token is not expired, keep the user.
      if (jwtToken.isExpired === false) {
        return;
      }

      clearInterval(this.interval);

      Store.getConfigurator().dispatch({
        type: Constants.PAGE_CHECK_EMAIL_ADD_SIGNOUT_REASON,
        payload: {
          signoutReason: Translator.trans("be_token_invalid")
        }
      });

      Store.getConfigurator().dispatch({
        type: Constants.PAGE_SIGNOUT_START
      });
    }, 1000);
  }

  public attachInitialToken(): void {
    Http.setBearer(this.getInstant());
  }

  public getInstant(): string {
    return Storage.getInstant("token");
  }

  public get(): Promise<string> {
    return Storage.get("token");
  }

  public set(token): Promise<string> {
    return Storage.set("token", token)
    .then(() => {
      return Http.setBearer(token);
    });
  }
}

export default new Token();
